import { useEffect } from "react";
import i18next from "src/i18n/config";
import authService from "src/services/authService";
import { toAppUrl } from "src/services/configService";
import ElasticService from "src/services/elasticService";

import { Box, CircularProgress } from "@mui/material";
import { showErrorToast } from "@shared/toasts/Toasts";

// The page the identity provider sends the user back to after they finish logging in.
// OAuth requires us to register one fixed URL up front where the IdP can drop the user
// once authentication is done — that URL is `/authorization/callback`, and this component handles it.
// There's nothing here to look at beyond a spinner; the real job is to read the
// `?code=...&state=...` the IdP appended to the URL, hand them to authService to swap
// for a session token, and then forward the user to wherever they were originally
// trying to go before the login detour.
// Reference: https://auth0.com/docs/get-started/authentication-and-authorization-flow/authorization-code-flow-with-pkce

const CallbackPage = () => {
    useEffect(() => {
        void (async () => {
            const result = await authService.handleAuthCallback(window.location.search);
            if (!result.ok) {
                const message = result.message ?? i18next.t("common:toast.generalError");
                showErrorToast(message);
                window.location.href = toAppUrl("/login");
                return;
            }

            ElasticService.updateUserContext();
            // External redirects (e.g. back to the forum) are absolute URLs and must not be run
            // through toAppUrl, which prepends BASE_URL and strips leading slashes.
            window.location.href = result.external ? result.redirectTo : toAppUrl(result.redirectTo);
        })();
    }, []);

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <CircularProgress size={70} />
        </Box>
    );
};

export default CallbackPage;
